import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { BeanMonitoryExclusion } from 'src/bean/BeanMonitoryExclusion';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExclusaoMonitoriaPendenteService {

  private readonly URL_LISTARPENDENCIAS = environment.urlBackend + environment.listarExclusoesPendentes;
  private readonly URL_ATUALIZAR_SOLICITACAO = environment.urlBackend + environment.solicitarExclusaoFicha;

  constructor(
    private http: HttpClient
  ) { }

  public getHeaders() {

    const tokenString = localStorage.getItem('access_token');

    const headers = {
      'Authorization': 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };

    return headers;
  }

  public list(): Promise<any> {
    const headers = this.getHeaders();
    return this.http.get(this.URL_LISTARPENDENCIAS, { headers }).toPromise().then((resposta: BeanMonitoryExclusion[]) => resposta)
  }

  public update(exclusionId: number, monitoryExclusion: BeanMonitoryExclusion): Observable<any> {
    const headers = this.getHeaders();
    return this.http.put(`${this.URL_ATUALIZAR_SOLICITACAO}/${exclusionId}`, monitoryExclusion, { headers })
      .pipe(
        tap((response: any) => console.log(response))
      );
  }

}
